import * as React from 'react';
import './styles.scss';

const NeedToSell = () => {
  return (
    <div className="need-to-sell-container">
      <h2 className="need-to-sell-container-heading"> Through our extensive knowledge of the business, network of resources, and years of expertise, we can assist homeowners with a wide variety of real estate problems. We pride ourselves on our reputation for working one-on-one with each customer to handle their individual situation. Since we’ve begun serving others, we have helped homeowners and their communities in each and every city we work in.</h2>

      <h3 className="need-to-sell-container-description">
        <em>
          We are here to help you achieve that goal!
        </em>
      </h3>
      {/* <p className="need-to-sell-container-paragraph">(See the video below for more info)</p> */}
    </div>
  );
};

export default NeedToSell;
